export class Item{
    id:number;
    name:string;
    value:string;
    imgsrc:string;
}
 
export const ITEMS: Item[] = [
    {
        id:1,
        name:'Item 1',
        value:'Go Die',
        imgsrc:'../assets/images/1.png'
     },
     {  id:2,
         name:'Item 2',
         value:'You are a lost cause',
         imgsrc:'../assets/images/2.png'
      },
      { id:3,
          name:'Item 3',
          value:'You REALLY need to improve',
          imgsrc:'../assets/images/3.png'
       },
       { id:4,
           name:'Item 4',
           value:'You need to improve',
           imgsrc:'../assets/images/4.png'
        },
        { id:5,
            name:'Item 5',
            value:'I am on the Fence',
            imgsrc:'../assets/images/5.png'
         },
         { id:6,
            name:'Item 6',
            value:'Okay',
            imgsrc:'../assets/images/6.png'
         },
         { id:7,
            name:'Item 7',
            value:'That was Nice',
            imgsrc:'../assets/images/7.png'
         },
         { id:8,
            name:'Item 8',
            value:'Yeah, it was Good',
            imgsrc:'../assets/images/8.png'
         },
         { id:9,
            name:'Item 9',
            value:'I cannot say it was perfect',
            imgsrc:'../assets/images/9.png'
         },
         { id:10,
            name:'Item 10',
            value:'Experience was Awesome',
            imgsrc:'../assets/images/10.png'
         }


];


// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/rating-data.ts